var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"type":"is-info","title":"Kunde abmelden","loading":_vm.checkoutLoading},on:{"click":_vm.checkoutVisitor}},[_c('b-icon',{attrs:{"icon":"door-open"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }